import { useScheduleEditorDeleteItemMutation } from '@graphql/generated';
import { useCallback } from 'react';

type DeleteOptions = {
  refetch?: string[];
};

export const useDeleteScheduleItem = (options: DeleteOptions) => {
  const { refetch } = options;
  const [mutation] = useScheduleEditorDeleteItemMutation();

  const deleteScheduleItem = useCallback(
    async (scheduleItemId: string) => {
      const { data, errors } = await mutation({
        variables: {
          payload: {
            scheduleId: scheduleItemId,
          },
        },
        refetchQueries: refetch ?? [],
      });

      if (!data || errors) {
        throw new Error('Failed to delete item');
      }

      return data;
    },
    [mutation, refetch],
  );

  return { deleteScheduleItem };
};
